export const cargoQuantity = [
  {
    id: "1吨以下",
    title: "1吨以下",
  },
  {
    id: "1-5吨",
    title: "1-5吨",
  },
  {
    id: "5-10吨",
    title: "5-10吨",
  },
  {
    id: "10-15吨",
    title: "10-15吨",
  },
  {
    id: "15-20吨",
    title: "15-20吨",
  },
  {
    id: "20-25吨",
    title: "20-25吨",
  },
  {
    id: "25-30吨",
    title: "25-30吨",
  },
  {
    id: "30-35吨",
    title: "30-35吨",
  },
  {
    id: "35-40吨",
    title: "35-40吨",
  },
  {
    id: "40-45吨",
    title: "40-45吨",
  },
  {
    id: "45-50吨",
    title: "45-50吨",
  },
  {
    id: "50吨以上",
    title: "50吨以上",
  },
];
